// extracted by mini-css-extract-plugin
export var founderAndStaffStory = "index-module--founderAndStaffStory--xHYx5";
export var founderBody = "index-module--founderBody--Jq8o6";
export var founderStory = "index-module--founderStory--toaEi";
export var staffBody = "index-module--staffBody--lU-tc";
export var staffStory = "index-module--staffStory--rIeLQ";
export var story = "index-module--story--+wpjX";
export var storyImage = "index-module--storyImage--3bGvn";